/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CloseWorkDayResponseDto } from '../models/close-work-day-response-dto';
import { glsControllerCloseShipments } from '../fn/gls-shipments/gls-controller-close-shipments';
import { GlsControllerCloseShipments$Params } from '../fn/gls-shipments/gls-controller-close-shipments';
import { glsControllerCreateParcel } from '../fn/gls-shipments/gls-controller-create-parcel';
import { GlsControllerCreateParcel$Params } from '../fn/gls-shipments/gls-controller-create-parcel';
import { glsControllerGetShipmentList } from '../fn/gls-shipments/gls-controller-get-shipment-list';
import { GlsControllerGetShipmentList$Params } from '../fn/gls-shipments/gls-controller-get-shipment-list';
import { glsControllerGetShipmentListByStatus } from '../fn/gls-shipments/gls-controller-get-shipment-list-by-status';
import { GlsControllerGetShipmentListByStatus$Params } from '../fn/gls-shipments/gls-controller-get-shipment-list-by-status';
import { ListSpedResponseDto } from '../models/list-sped-response-dto';
import { ParcelResponseDto } from '../models/parcel-response-dto';

@Injectable({ providedIn: 'root' })
export class GlsShipmentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `glsControllerCreateParcel()` */
  static readonly GlsControllerCreateParcelPath = '/couriers/gls/add-parcel';

  /**
   * Create a new GLS Parcel.
   *
   * Creates a new shipment with GLS courier service and returns tracking information
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `glsControllerCreateParcel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  glsControllerCreateParcel$Response(params: GlsControllerCreateParcel$Params, context?: HttpContext): Observable<StrictHttpResponse<ParcelResponseDto>> {
    return glsControllerCreateParcel(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new GLS Parcel.
   *
   * Creates a new shipment with GLS courier service and returns tracking information
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `glsControllerCreateParcel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  glsControllerCreateParcel(params: GlsControllerCreateParcel$Params, context?: HttpContext): Observable<ParcelResponseDto> {
    return this.glsControllerCreateParcel$Response(params, context).pipe(
      map((r: StrictHttpResponse<ParcelResponseDto>): ParcelResponseDto => r.body)
    );
  }

  /** Path part for operation `glsControllerGetShipmentList()` */
  static readonly GlsControllerGetShipmentListPath = '/couriers/gls/list-sped';

  /**
   * List all shipments.
   *
   * Retrieve a list of all shipments from the GLS service
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `glsControllerGetShipmentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  glsControllerGetShipmentList$Response(params?: GlsControllerGetShipmentList$Params, context?: HttpContext): Observable<StrictHttpResponse<ListSpedResponseDto>> {
    return glsControllerGetShipmentList(this.http, this.rootUrl, params, context);
  }

  /**
   * List all shipments.
   *
   * Retrieve a list of all shipments from the GLS service
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `glsControllerGetShipmentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  glsControllerGetShipmentList(params?: GlsControllerGetShipmentList$Params, context?: HttpContext): Observable<ListSpedResponseDto> {
    return this.glsControllerGetShipmentList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ListSpedResponseDto>): ListSpedResponseDto => r.body)
    );
  }

  /** Path part for operation `glsControllerGetShipmentListByStatus()` */
  static readonly GlsControllerGetShipmentListByStatusPath = '/couriers/gls/list-sped-by-status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `glsControllerGetShipmentListByStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  glsControllerGetShipmentListByStatus$Response(params?: GlsControllerGetShipmentListByStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<any>>> {
    return glsControllerGetShipmentListByStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `glsControllerGetShipmentListByStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  glsControllerGetShipmentListByStatus(params?: GlsControllerGetShipmentListByStatus$Params, context?: HttpContext): Observable<Array<any>> {
    return this.glsControllerGetShipmentListByStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<any>>): Array<any> => r.body)
    );
  }

  /** Path part for operation `glsControllerCloseShipments()` */
  static readonly GlsControllerCloseShipmentsPath = '/couriers/gls/close-work-day';

  /**
   * Close workday for shipments.
   *
   * Close the workday for all shipments that are awaiting closure
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `glsControllerCloseShipments()` instead.
   *
   * This method doesn't expect any request body.
   */
  glsControllerCloseShipments$Response(params?: GlsControllerCloseShipments$Params, context?: HttpContext): Observable<StrictHttpResponse<CloseWorkDayResponseDto>> {
    return glsControllerCloseShipments(this.http, this.rootUrl, params, context);
  }

  /**
   * Close workday for shipments.
   *
   * Close the workday for all shipments that are awaiting closure
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `glsControllerCloseShipments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  glsControllerCloseShipments(params?: GlsControllerCloseShipments$Params, context?: HttpContext): Observable<CloseWorkDayResponseDto> {
    return this.glsControllerCloseShipments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CloseWorkDayResponseDto>): CloseWorkDayResponseDto => r.body)
    );
  }

}
